// extracted by mini-css-extract-plugin
export default {"subtitle":"ChildInfo-module__subtitle--sIRx7","card":"ChildInfo-module__card--_TF3n"};